// DTO sdílené mezi frontend (React), backend (Hono) a ingest (GH Action skript).
// Pravidlo: změny tady = vždy promyslet kompatibilitu na všech třech místech.

export type Category =
  | 'regulation'
  | 'prices'
  | 'infrastructure'
  | 'projects'
  | 'geopolitics'
  | 'economy';

export type Role = 'admin' | 'broker';

export type SourceType = 'rss' | 'wp_rest' | 'google_news' | 'html';

export interface MeUser {
  id: string;
  email: string;
  name: string;
  pictureUrl: string | null;
  role: Role;
}

export interface MeResponse {
  user: MeUser;
}

export interface SourceDto {
  id: string;
  name: string;
  type: SourceType;
  url: string;
  configJson: string | null;
  trustScore: number;
  isEnabled: boolean;
  lastFetchedAt: number | null;
  lastStatus: string | null;
  failCount: number;
  createdAt: number;
  updatedAt: number;
}

export interface QueryDto {
  id: string;
  label: string;
  queryString: string;
  isEnabled: boolean;
  createdAt: number;
  updatedAt: number;
}

export interface FeedItemDto {
  id: string;
  rank: number;
  category: Category | string;
  titleCz: string;
  tldrCz: string;
  tldrEn: string | null;
  sourceName: string;
  sourceUrl: string;
  publishedAt: number | null;
  pickedAt: number;
}

export interface FeedRunInfo {
  id: string;
  startedAt: number;
  finishedAt: number | null;
}

export interface TodayFeedResponse {
  data: {
    run: FeedRunInfo | null;
    items: FeedItemDto[];
  };
}

export type LangCode = 'cs' | 'en' | 'pl' | 'vi';

export const LANGS: { code: LangCode; label: string; flag: string }[] = [
  { code: 'cs', label: 'Česky', flag: '🇨🇿' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'pl', label: 'Polski', flag: '🇵🇱' },
  { code: 'vi', label: 'Tiếng Việt', flag: '🇻🇳' },
];

export interface ProfileDto {
  userId: string;
  phone: string | null;
  signatureCs: string | null;
  signatureEn: string | null;
  signaturePl: string | null;
  signatureVi: string | null;
  avatarUrl: string | null;
  emailDigestEnabled: boolean;
  emailDigestTime: string | null;
  updatedAt: number;
}

export interface BroadcastDto {
  bodyCs: string;
  bodyEn: string;
  bodyPl: string | null;
  bodyVi: string | null;
  generatedAt: number;
  cached: boolean;
}

export interface NewsletterDto {
  bodyCs: string;
  bodyEn: string;
  bodyPl: string | null;
  bodyVi: string | null;
  generatedAt: number;
  cached: boolean;
}

export interface NewsletterArchiveItem {
  id: string;
  generatedAt: number;
  model: string;
  bodyCs: string;
  bodyEn: string;
  bodyPl: string | null;
  bodyVi: string | null;
  items: Array<{
    id: string;
    titleCz: string;
    sourceName: string;
    sourceUrl: string;
    category: string;
  }>;
}

export interface RunDto {
  id: string;
  triggeredBy: string;
  startedAt: number;
  finishedAt: number | null;
  status: 'running' | 'success' | 'partial' | 'failed';
  stats: Record<string, number | string> | null;
  error: string | null;
}

export interface RunDetailDto {
  run: RunDto;
  logs: Array<{
    step: string;
    level: 'info' | 'warn' | 'error';
    message: string;
    ts: number;
    payload: unknown | null;
  }>;
  items: Array<{
    rank: number;
    category: string;
    titleCz: string;
    sourceName: string;
  }>;
}
